export default "__VITE_ASSET__4B0YKweK__"